import styled from '@emotion/styled';
import Image from '@base/Image';
import H6 from '@base/H6/H6';
import H4 from '@base/H4/H4';
import { Spacings } from '@styles/index';
import boxShadowGenerator from '@utils/boxShadowGenerator';

const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background: transparent;
  padding: ${Spacings.SPACING_6B};
  width: 356px;
  height: 198px;
  background: var(--color-base-1);
  box-shadow: ${boxShadowGenerator()};
  border-radius: ${Spacings.SPACING_2B};
`;
const SubTitle = styled(H6)`
  margin-top: ${Spacings.SPACING_1B};
  color: var(--color-text-secondary);
  font-weight: normal;
`;

const Title = styled(H4)`
  margin-top: ${Spacings.SPACING_4B};
`;

const BatchStatusCard = ({ imageUrl, title, subTitle }) => {
  return (
    <CardContainer>
      {imageUrl && <Image src={imageUrl} alt="icon" width={80} height={80} />}
      {title && <Title>{title}</Title>}
      {subTitle && <SubTitle>{subTitle}</SubTitle>}
    </CardContainer>
  );
};

export default BatchStatusCard;
